import classNames from 'classnames';
import styles from './OptionsToggle.module.scss';

interface OptionsToggleProps {
	options: {
		label: string;
		value: string;
	}[];
	value: string;
	className?: string;
	dataCy?: string;
	onChange: (value: string) => void;
}

const OptionsToggle = ({
	options,
	value,
	className,
	dataCy = 'optionsToggle',
	onChange,
}: OptionsToggleProps) => {
	return (
		<div className={classNames(styles.container, className)} data-cy={dataCy}>
			{options?.map((o) => (
				<div
					key={o.value}
					className={classNames(styles.option, { [styles.active]: value === o.value })}
					onClick={() => onChange(o.value)}
					data-cy={o.value}
				>
					{o.label}
				</div>
			))}
		</div>
	);
};

export default OptionsToggle;
